import styled from "styled-components"

import Flex from "@irati/ui/src/Flex"

export default styled(Flex)`
  cursor: pointer;
`
